import React from 'react';

const ImageModal = ({ isOpen, image, onClose }) => {
  if (!isOpen || !image) {
    return null;
  }

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="image-modal-overlay" onClick={handleOverlayClick}>
      <div className="image-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="image-modal-header">
          <h3>Sensor Image</h3>
          <button 
            className="image-modal-close"
            onClick={onClose}
            aria-label="Close modal"
          >
            ×
          </button>
        </div>
        <div className="image-modal-body">
          <img 
            src={image.url} 
            alt="Sensor image"
            className="image-modal-image"
            onError={(e) => {
              e.target.style.display = 'none';
              e.target.nextSibling.style.display = 'block';
            }}
          />
          <div className="image-modal-fallback" style={{ display: 'none' }}>
            <p>Failed to load image</p>
          </div>
          {image.lastModified && (
            <p className="image-modal-timestamp">
              Captured: {new Date(image.lastModified).toLocaleString()}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default ImageModal;